import React, { useState } from "react";
import { dbURL } from "./global";
import { useNavigate } from "react-router-dom";

function Login(props) {
  const [secondStep, setSecondStep] = useState(false);
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState(false);
  const navigate = useNavigate();

  function handleUser(e) {
    setUser(e.target.value);
  }

  function handlePassword(e) {
    setPassword(e.target.value);
  }

  function handleSubmitUser(e) {
    e.preventDefault();
    if (user.length) setSecondStep(true);
  }

  function handleSubmitPassword(e) {
    e.preventDefault();

    logPHP();
  }

  function handleComeBack(e) {
    e.preventDefault();
    setSecondStep(false);
    setErrorMessage(false);
    setUser("");
    setPassword("");
  }

  async function logPHP() {
    const logInfo = await fetch(`${dbURL}login.php`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify({
        login: user,
        password: password,
      }),
    });

    const result = await logInfo.json();
    if (result.loggedIn) {
      props.setLoggedIn(true);

      navigate("/app");
    } else if (!result || result.message) {
      setErrorMessage(result.message);
    }
  }

  const StepOne = () => {
    return (
      <div className="stepOne">
        <form>
          <div className="form-row">
            <div className="logIcon">
              <img src="./images/user-profile.svg"></img>
            </div>
            <input
              type="text"
              placeholder="Wprowadź nazwę użytkownika"
              name="user"
              value={user}
              onChange={handleUser}
              autoFocus
            ></input>
          </div>
          <input type="submit" value="Przejdź dalej" onClick={handleSubmitUser}></input>
        </form>
      </div>
    );
  };

  const StepTwo = () => {
    return (
      <div className="stepTwo">
        <form>
          {!errorMessage ? (
            <div className="form-row">
              <div className="logIcon">
                <img src="./images/door-key.svg"></img>
              </div>
              <input
                type="password"
                placeholder={"Hasło dla " + user}
                name="password"
                value={password}
                onChange={handlePassword}
                autoFocus
              ></input>
            </div>
          ) : (
            <div className="errorMessage">{errorMessage}</div>
          )}
          {!errorMessage ? (
            <input
              type="submit"
              value="Zaloguj się"
              style={{ opacity: 0.15 + password.length * 0.33 }}
              onClick={handleSubmitPassword}
            ></input>
          ) : (
            <input
              type="submit"
              className="backToLogin"
              value="Powrót"
              onClick={handleComeBack}
            ></input>
          )}
        </form>
      </div>
    );
  };

  return (
    <div className="loginWrap">
      <div className="login">
        {secondStep ? null : <StepOne />}
        {secondStep ? <StepTwo /> : null}
      </div>
    </div>
  );
}

export default Login;
